export const routes = {
	root: "/",
	authCallback: "/authcallback",
	quoteDetails: "/quote-details",
	createFTLQuote: "/create-ftl-quote",
	quoteDetailsWithId: "/quote-details/:quoteId",
	carrierSelection: "/carrier-selection/:quoteId",
	shipmentDetails: "/shipment-details/:quoteId",
	profile: "/profile",
	track: "/track",
	tender: "/tender",
	payment: "/payment",
	settings: "/settings",
	feedback: "/feedback",
	quotes: "/quotes",
	addressBook: "/settings/address-book",
	addressBookWithCustomer: "/settings/address-book/:customerId",
	addressBookEdit: "/settings/address-book/:customerId/edit/:addressBookItemId",
	routingGuides: "/settings/routing-guides",
	routingGuidesGlobal: "/settings/routing-guides/global",
	routingGuidesWithCustomer: "/settings/routing-guides/:customerId",
	admin: "/settings/admin",
	adminWithCustomer: "/settings/admin/:customerId",
	mySettings: "/settings/my-settings",
	accountSettings: "/settings/account-settings",
	commodities: "/commodities",
	commoditiesWithCustomer: "/commodities/:customerId",
	shipmentManagement: "/shipment-management/:poNumber",
	ftlShipment: "/ftl-shipment",
	ltlShipment: "/ltl-shipment",
	ltlShipmentWithId: "/ltl-shipment/:quoteId",
	ltlShipmentCarrierSelection: "/ltl-shipment/carrier-selection/:quoteId",
	templates: "/templates",
	notifications: "/settings/notifications",
	notificationsWithCustomer: "/settings/notifications/:customerId",
	templatesWithCustomer: "/templates/:customerId",
	autoDispatchGlobal: "/auto-dispatch/global",
	autoDispatch: "/auto-dispatch",
	autoDispatchWithCustomer: "/auto-dispatch/:customerId",
	arDashboard: "/ar-dashboard",
	reports: "/reports",
	reportsWithId: "/reports/:reportId",
	reportsWithIdAndCustomer: "/reports/:reportId/:customerId",
	trackShipment: "/shipment-tracking",
	vendorManagement: "/settings/vendor-management",
	vendorManagementWithCustomer: "/settings/vendor-management/:customerId",
	shipmentRerateCarrierSelection: "/rerate/carrier-selection/:quoteId",
} as const;

/**
 * Internal-only routes that should not be accessible to external B2C users.
 * Add new internal routes here to prevent external users from accessing them.
 */
export const INTERNAL_ONLY_ROUTE_KEYS = [
	"shipmentManagement",
	"autoDispatch",
	"autoDispatchGlobal",
	"autoDispatchWithCustomer",
	"routingGuides",
	"routingGuidesGlobal",
	"routingGuidesWithCustomer",
	"arDashboard",
] as const;
